import * as React from 'react'
import type { SVGProps } from 'react'
const SvgMagicWand2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.5431 3.5429c1.0809-1.0809 2.8333-1.0809 3.9142 0s1.0809 2.8333 0 3.9142l-13 13c-1.0809 1.0809-2.8333 1.0809-3.9142 0s-1.0809-2.8333 0-3.9142zm2.5 1.4142a.768.768 0 0 0-1.0858 0L16.1644 6.75l1.0858 1.0858 1.7929-1.793a.768.768 0 0 0 0-1.0857M15.836 9.25l-1.0858-1.0858-9.7929 9.7929a.7678.7678 0 1 0 1.0858 1.0858z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M9.8503 2.0745a.5.5 0 0 0 .2236-.2236l.4782-.9565c.1843-.3685.7102-.3685.8945 0l.4782.9565a.5.5 0 0 0 .2236.2236l.9565.4783c.3685.1843.3685.7102 0 .8944l-.9565.4783a.5.5 0 0 0-.2236.2236l-.4782.9565c-.1843.3685-.7102.3685-.8945 0l-.4782-.9565a.5.5 0 0 0-.2236-.2236l-.9565-.4783c-.3686-.1842-.3686-.7101 0-.8944zM18.8503 13.0745a.5.5 0 0 0 .2236-.2236l.4782-.9565c.1843-.3685.7102-.3685.8945 0l.4782.9565a.5.5 0 0 0 .2236.2236l.9565.4783c.3685.1843.3685.7102 0 .8944l-.9565.4783a.5.5 0 0 0-.2236.2236l-.4782.9565c-.1843.3685-.7102.3685-.8945 0l-.4782-.9565a.5.5 0 0 0-.2236-.2236l-.9565-.4783c-.3686-.1842-.3686-.7101 0-.8944zM4.8503 7.0745a.5.5 0 0 0 .2236-.2236l.4782-.9565c.1843-.3685.7102-.3685.8945 0l.4782.9565a.5.5 0 0 0 .2236.2236l.9565.4783c.3685.1843.3685.7102 0 .8944l-.9565.4783a.5.5 0 0 0-.2236.2236l-.4782.9565c-.1843.3685-.7102.3685-.8945 0l-.4782-.9565a.5.5 0 0 0-.2236-.2236l-.9565-.4783c-.3685-.1842-.3685-.7101 0-.8944z"
    />
  </svg>
)
export default SvgMagicWand2
